{
  "Temporal coverage": "Couverture temporelle",
  "Frequency": "Fréquence",
  "Spatial coverage": "Couverture spatiale",
  "Territorial coverage granularity": "Granularité de la couverture territoriale",
  "resources": "ressources",
  "reuses": "réutilisations",
  "favourites": "favoris",
  "Admin": "Admin",
  "Reply to the discussion": "Répondre à la discussion",
  "Comment": "Commentaire",
  "Reply as": "Répondre en tant que",
  "Submit": "Soumettre",
  "Error sending response": "Erreur lors de l'envoi de la réponse",
  "Discussion closed": "Discussion fermée",
  "messages": "messages",
  "Reply": "Répondre",
  "The discussion was closed by": "La discussion a été close par",
  "on": "le",
  "Start a new discussion": "Démarrer une nouvelle discussion",
  "New discussion": "Nouvelle discussion",
  "Title": "Titre",
  "Message": "Message",
  "You are seeing a specific discussion about this dataset": "Vous consultez une discussion spécifique sur ce jeu de données",
  "See all discussions about this dataset": "Voir toutes les discussions sur ce jeu de données",
  "Discussion creation": "Début de discussion",
  "Last reply": "Dernière réponse",
  "An error occurred while fetching discussions": "Une erreur est survenue lors de la récupération des discussions",
  "An error occurred while fetching the discussion ": "Une erreur est survenue lors de la récupération de la discussion ",
  "An error occurred while creating the discussion ": "Une erreur est survenue lors de la création de la discussion ",
  "There are no results for your search": "Aucun résultat ne correspond à votre recherche",
  "from": "du",
  "to": "à",
  "Search...": "Rechercher...",
  "Search for data...": "Rechercher des données...",
  "Datasets": "Jeux de données",
  "Datasets-total": "datasets total",
  "Search reuses": "Rechercher dans les réutilisations",
  "Search filters": "Critères de recherche",
  "Organizations": "Organisations",
  "Search an organization...": "Chercher une organisation...",
  "Tags": "Mots clés",
  "Search a tag...": "Chercher un mot clé...",
  "Licenses": "Licences",
  "Search a license...": "Chercher une licence...",
  "Formats": "Formats",
  "Search a format...": "Chercher un format...",
  "Geographic area": "Zone géographique",
  "Search a geographic area...": "Chercher une zone...",
  "Territorial granularity": "Granularité territoriale",
  "Search a granularity...": "Chercher une granularité...",
  "Reset filters": "Réinitialiser les filtres",
  "No dataset matching your query": "Nous n’avons pas de jeu de données correspondant à votre requête",
  "You can try to reset the filters to expand your search.": "Vous pouvez essayer de réinitialiser les filtres pour agrandir votre champ de recherche.",
  "Search for data, reuses, contributions...": "Rechercher des données, réutilisations, contributions...",
  "Search all datasets": "Rechercher dans tous les jeux de données",
  "See all datasets": "Voir tous les jeux de données",
  "Search in datasets": "Rechercher dans les jeux de données",
  "Search in reuses": "Rechercher dans toutes les réutilisations",
  "See the reuses": "Voir toutes les réutilisations",
  "No reuse matching your query": "Nous n’avons pas de réutilisation correspondant à votre requête",
  "No results found.": "Aucun résultat.",
  "Reuses": "Réutilisations",
  "Datasets are collections of data, i.e. structured information, easily readable by a machine.": "Les jeux de données sont des recueils de données, c’est-à-dire des informations structurées, facilement lisibles par une machine.",
  "Reuses refer to the use of data for an other purpose than the one they were produced for.": "Les réutilisations désignent l’utilisation des données à d’autres fins que celle de la mission pour laquelle les données ont été produites.",
  "Ask to join the organization as a producer": "Demander à rejoindre l'organisation en tant que producteur",
  "You can add some details here for your membership request": "Vous pouvez ajouter des détails sur votre demande d'adhésion",
  "A request has been sent to the administrators": "Une demande a été envoyée aux administrateurs",
  "Error while requesting membership": "Erreur lors de la demande d'adhésion",
  "Read more": "Lire plus",
  "Read less": "Lire moins",
  "remove from favorites": "retirer des favoris",
  "add to favorites": "ajouter aux favoris",
  "Page": "Page {nb}",
  "First page": "Première Page",
  "Previous page": "Page précédente",
  "Next page": "Page suivante",
  "Last page": "Dernière page",
  "downloads": "téléchargements",
  "Nameless resource": "Ressource sans nom",
  "See more details": "Voir plus de détails",
  "Preview": "Prévisualiser",
  "Copy permalink to clipboard": "Copier le lien dans le presse-papiers",
  "Resource link": "Lien de la ressource",
  "Download resource": "Télécharger la ressource",
  "URL": "URL",
  "Permalink": "URL stable",
  "Type": "Type",
  "MIME Type": "Type MIME",
  "Created on": "Créée le",
  "Modified on": "Modifiée le",
  "Published on": "Publiée le",
  "An error occurred while fetching resources": "Une erreur est survenue lors de la récupération des ressources",
  "Edit resource": "Modifier la ressource",
  "See schema": "Voir le schéma",
  "Associated schema": "Schéma associé",
  "This resource is associated to the schema ": "Cette ressource est associée au schéma ",
  "this means that the producer reports that it adheres to the specification.": "ce qui signifie que le producteur a déclaré qu'elle en respectait la spécification.",
  "Documentation": "Documentation",
  "You can view the schema documentation, discover some context and recommendations for data producers.": "Vous pouvez consulter la documentation de ce schéma, découvrir le contexte et les recommandations destinées aux producteurs de données.",
  "Read documentation": "Lire la documentation",
  "Validation": "Validation",
  "Resource validation based on a schema is a way to verify that the resource complies to the schema it is supposed to abide by. In case of errors, a validation report shows the errors found: wrongly named columns, non conform values, etc.": "La validation d'une ressource par rapport à un schéma consiste à vérifier que la ressource est bien conforme au schéma qu'elle est censée respecter. En cas d'erreurs, un rapport de validation indique les erreurs trouvées : colonnes mal nommées, valeurs non conformes etc.",
  "data.gouv.fr allows you to validate your files based on a schema and correct the possible errors.": "data.gouv.fr met à votre disposition un outil pour valider vos fichiers par rapport à un schéma et corriger les éventuelles erreurs.",
  "Validate resource": "Valider la ressource",
  "Others resources": "Autres ressources",
  "You can specify that a resource complies to a schema on your producer dashboard. Other resources complying with the schema are available on the platform.": "Il est possible de spécifier qu'une ressource respecte un schéma depuis l'espace d'administration en tant que producteur. Plusieurs ressources respectant ce schéma sont disponibles sur la plateforme.",
  "See dataset linked to this schema": "Voir les jeux de données associés à ce schéma",
  "About schemas": "À propos des schémas",
  "Data schemas allow to describe data models : what are the fields, how is data represented, what are the possible values. Discover how schemas improve data quality and use cases on ": "Les schémas de données permettent de décrire des modèles de données : quels sont les différents champs, comment sont représentées les données, quelles sont les valeurs possibles. Découvrez comment les schémas améliorent la qualité des données et quels sont les cas d'usages possibles sur ",
  "Available": "Disponible",
  "Unavailable": "Indisponible",
  "Close": "Fermer",
  "Copy permalink": "Copier le lien vers la discussion",
  "Discussions": "Discussions",
  "Error getting search results.": "Erreur lors de l'obtention des résultats de la recherche.",
  "Sort discussions by": "Trier les discussions par",
  "Private": "Privé",
  "Unfeature this content": "Ne plus mettre en avant ce contenu",
  "Feature this content": "Mettre ce contenu en avant",
  "Preview of resource X": "Prévisualisation de la ressource {title}",
  "An error occurred while featuring this subject.": "",
  "Created date asc": "Created date asc",
  "Created date desc": "Created date desc",
  "Last modified asc": "Last modified asc",
  "Last modified desc": "Last modified desc",
  "Title asc": "Title asc",
  "Title desc": "Title desc",
  "Followers asc": "Followers asc",
  "Followers desc": "Followers desc",
  "Reuses asc": "Reuses asc",
  "Reuses desc": "Reuses desc",
  "Download datasets": "Preuzmi podatke",
  "Download resources": "Preuzmi primere upotrebe",
  "sort by": "",
  "Documents": "Документа",
  "Documents and instructions": "Документа и упутства",
  "Law and by laws": "Закон и подзаконска акта",
  "Instructions": "Упутства",
  "Sort by": "",
  "Search by sort...": "Raspored prema..."
}